import PropTypes from 'prop-types';
import React from 'react';
import Tag from '../../../Elements/Tag/Tag';

import FGBLabel from '../../../Elements/FGBLabel/FGBLabel';
import CardHeader from '../../../Groups/CardHeader/CardHeader';
import InterestTypeahead from '../../../Groups/InterestTypeahead/InterestTypeahead';
import SkillsIcon from '../../../Icons/UserProfile/Skills';
import Button from '../../../Input/Button/Button';
import { USER_PROFILE_KEYS } from '../../../Includes/Constants/user';
import './UserInterests.scss';

// constants
const setNameToOption = ({ id, name, parent }) => ({
    id,
    name,
    option: parent ? parent.name : name,
    parent: parent || null,
});
const typeaheadFieldLabelProps = {
    label: 'What are you great at?',
    shouldShowTooltip: false,
};

export default class UserInterests extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            interests: props.interests.map(setNameToOption),
            updatedInterests: props.interests.map(setNameToOption),
            inputError: '',
        };
    }

    static propTypes = {
        /**
         * array of user interests
         */
        interests: PropTypes.array.isRequired,
        /**
         * function for adding/updating interests
         */
        onSubmit: PropTypes.func,
        /**
         * string of error
         */
        apiError: PropTypes.string,
        /**
         * boolean whether user is editing
         */
        editMode: PropTypes.bool,
        /**
         * function to exit edit mode
         */
        toggleEditMode: PropTypes.func,
    };

    static defaultProps = {
        interests: [],
        onSubmit: () => {},
        editMode: false,
        toggleEditMode: () => {},
        apiError: null,
    };

    updateInterests = (newInterests) => {
        this.setState({ interests: newInterests });

        const payload = newInterests.map(({ id, name }) => ({ id, name }));

        this.props.onSubmit(USER_PROFILE_KEYS.INTERESTS, payload);
    };

    handlePreventEventDefault = (event) => {
        event && event.preventDefault();
    };

    handleFormSubmit = async (event) => {
        this.handlePreventEventDefault(event);

        const payload = {
            interests: this.state.interests.map(({ id, name }) => ({
                id,
                name,
            })),
        };

        this.props.onSubmit(payload, 'interests');

        if (!this.props.apiError) {
            this.setState(({ interests }) => ({
                updatedInterests: interests,
                inputError: '',
            }));
            return true;
        }
    };

    handleError = (inputError) => this.setState({ inputError });

    handleCancel = () => {
        this.setState(
            ({ updatedInterests }) => ({
                interests: updatedInterests,
                inputError: '',
            }),
            this.props.toggleEditMode
        );
    };

    renderTag = (item, index) => {
        return (
            <Tag
                key={`item-${index}`}
                tagCssClass="item-tags"
                svgCssClass="remove-item"
            >
                {item.option}
            </Tag>
        );
    };

    renderInterestsEditForm = () => {
        return (
            <form
                className="interest-typeahead-form"
                onSubmit={this.handlePreventEventDefault}
            >
                <InterestTypeahead
                    fieldLabelProps={typeaheadFieldLabelProps}
                    items={this.state.interests}
                    error={this.state.inputError || this.props.apiError}
                    onErrorUpdate={this.handleError}
                    onUpdate={this.updateInterests}
                    placeholder='For example, "Excel" or "Javascript"'
                />
            </form>
        );
    };

    renderInterestsSection = () => {
        const { editMode } = this.props;
        const { interests } = this.state;

        if (editMode) {
            return this.renderInterestsEditForm();
        }

        return (
            <div className="interest-tags">{interests.map(this.renderTag)}</div>
        );
    };

    render() {
        return (
            <div className="component-Users-UserProfile-UserInterests">
                <FGBLabel className="black-font">Professional Skills</FGBLabel>
                {this.renderInterestsSection()}
            </div>
        );
    }
}
